<nav
  aria-label="Left-Sidebar"
  tabindex="-1"
  class="new-sidebar-nav"
  id="side-navigation"
  [ngClass]="{ 'new-sidebar-collapsed': sidebarDesktop, 'new-sidebar-mobile-open': sidebarMobile }"
>
  <!-- Skip to main content - AA compliant, first focusable element -->
  <a href="#main-content" class="skip-to-main" (click)="skipToMain($event)">
    Skip to main content
  </a>

  <div class="new-sidebar-inner">
    <div class="new-sidebar-header" [ngClass]="{  'app-context': isInApplication }">
      <a [routerLink]="routeLink" class="new-sidebar-logo-link" [ngClass]="{ 'icon-only': icon }" aria-label="Go to Home">
        <ng-container *ngIf="!icon">
          <div class="logo-box">
            <img [src]="logoSrc" class="logo" alt="" />
          </div>
        </ng-container>
        <ng-container *ngIf="icon">
          <div class="logo-box icon-box">
            <i [class]="icon" [ngStyle]="{ color: iconColor }" aria-hidden="true"></i>
          </div>
        </ng-container>
      </a>
      <p class="app-name" *ngIf="isAppNameVisible">{{ appName }}</p>
      <button
        type="button"
        class="collapse-btn"
        [matTooltip]="sidebarDesktop ? 'Expand sidebar' : 'Collapse sidebar'"
        matTooltipPosition="right"
        [attr.aria-label]="sidebarDesktop ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-expanded]="!sidebarDesktop"
        [ngClass]="sidebarDesktop ? 'collapsed' : ''"
        (click)="toggleDesktop(true)"
      >
        <img src="assets/images/icons/left-panel-close.svg" alt="" class="collapse-icon" aria-hidden="true" />
      </button>

      <div class="mobile-menu desktop-hidden">
        <button
          type="button"
          class="mobile-menu-btn"
          (click)="toggleMobile()"
          id="menu-open"
          aria-label="Open menu"
          [attr.aria-expanded]="sidebarMobile"
          aria-controls="sidebar-menu"
        >
          <span class="navbar-toggler-icon"><i class="icon-menu"></i></span>
        </button>
      </div>
    </div>


    <div class="new-sidebar-menu" id="sidebar-menu" [ngClass]="sidebarMobile ? 'active' : ''">
      <a
        href="javascript:void(0)"
        class="close-mobile desktop-hidden"
        (click)="toggleMobile()"
        id="menu-closed"
        aria-label="Close menu"
      >
        <i class="icon-close"></i>
      </a>
      <div class="new-sidebar-menu-inner" #scrollContainer>
        <div class="nav-content">
          <div class="nav-list-wrapper">
            <app-new-side-navigation
              [navigations]="navigation"
              [externalCollapse]="isUserMenuOpen"
              (loadDefaultTable)="loadDefaultTablePage($event)"
              (panelExpanded)="isUserMenuOpen = false"
            >
            </app-new-side-navigation>
          </div>
        </div>
      </div>
      <div class="user-profile-bottom-pinned">
        <ul class="nav-list">
          <ng-container *ngTemplateOutlet="userProfile"></ng-container>
        </ul>
      </div>
    </div>

    <div
      id="cd-shadow-layer"
      class="backdrop-layer menu-closed"
      (click)="sidebarMobile && toggleMobile()"
      role="button"
      tabindex="-1"
      aria-label="Close menu"
    ></div>
  </div>
</nav>

<ng-template #userProfile>
  <li class="user-profile-item new-nav-item" id="menu-cloned-one">
    <button
      type="button"
      class="new-nav-toggle user-dropdown-trigger"
      [attr.aria-haspopup]="true"
      [attr.aria-expanded]="isUserMenuOpen"
      aria-controls="user-profile-panel"
      id="user-menu-toggle"
      (click)="toggleUserMenu()"
    >
      <span class="chevron" [class.expanded]="isUserMenuOpen" aria-hidden="true"></span>
      <span class="table-name user-name">{{ fullName() }}</span>
    </button>
    <div
      class="new-nav-panel user-profile-panel"
      id="user-profile-panel"
      aria-labelledby="user-menu-toggle"
      [class.expanded]="isUserMenuOpen"
    >
      <ul >
        <li class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="isCurrentUserProfilePage('/user/profile') ? 'page' : null" routerLink="/user/profile">Edit Profile</a>
        </li>
        <li class="new-sub-item" *ngIf="showAppLibraryInSidebar$ | async">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="isCurrentUserProfilePage('/apps') ? 'page' : null" routerLink="/apps">App Library</a>
        </li>
        <li *ngIf="isSuperAdmin && !isImpersonate" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="isCurrentUserProfilePage('/company') ? 'page' : null" routerLink="/company">Account Manager</a>
        </li>
        <li *ngIf="isBillingAdmin" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="companyId && isCurrentUserProfilePage('/company/' + companyId) ? 'page' : null" [routerLink]="'/company/' + companyId">Company Details</a>
        </li>
        <li *ngIf="isBillingAdmin" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="isCurrentUserProfilePage('/user/billing') ? 'page' : null" routerLink="/user/billing">Billing Admin</a>
        </li>
        <li *ngIf="isSuperAdmin && !isImpersonate" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" [attr.aria-current]="isCurrentUserProfilePage('/clients') ? 'page' : null" routerLink="/clients">Manage Clients</a>
        </li>
        <li *ngIf="isSuperAdmin && !isImpersonate" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" href="javascript:void(0)" (click)="executeTodayFormulas()">Run Today Formulas</a>
        </li>
        <li *ngIf="isHelpWidgetShow" class="new-sub-item">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" href="https://support.opengov.com/" target="_blank" rel="noopener">Help</a>
        </li>
        <li *ngIf="!isImpersonate && !isHideLogoutInPspShellEnabled" class="new-sub-item logout-li">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" href="javascript:void(0)" (click)="logout()">Sign out</a>
        </li>
        <li *ngIf="isImpersonate" class="new-sub-item logout-li">
          <a class="new-sub-link" [attr.tabindex]="isUserMenuOpen ? null : -1" href="javascript:void(0)" (click)="restoreSuperAdmin()">End Impersonate User</a>
        </li>
      </ul>
    </div>
  </li>
</ng-template>
